angular.module('env.custom.customModule.orderItemSummary', [])
    .constant('jsZip', window.JSZip)
    .controller('orderItemSummaryController', function ($log, $q, $scope, $timeout, toastr, attachmentsHelperService, authService, fileService, gettextCatalog, jsZip) {

        //var watcherDestructor = $scope.$watch(
        //    'orderItem',
        //    function (newVal, oldVal) {
        //        if (newVal && newVal !== oldVal && (!newVal.$model.expectedBy || newVal.$model.expectedBy.getFullYear() === 1)) {
        //            setDefaultCompletionDate(newVal);
        //        }
        //    }
        //);
        $scope.$on('$destroy', function () {
            //watcherDestructor();
        });

        $scope.exportFilesForTaika3D = function () {
            //Files to be zipped. Some of them needs to be downloaded first
            var filesToExport = [
                {
                    fileName: `${$scope.orderItem.$model.orderId}L.stl`,
                    documentId: attachmentsHelperService.getLeftFootScanFileNameId($scope.orderItem),
                    blob: null
                }, {
                    fileName: `${$scope.orderItem.$model.orderId}R.stl`,
                    documentId: attachmentsHelperService.getRightFootScanFileNameId($scope.orderItem),
                    blob: null
                }, {
                    fileName: `${$scope.orderItem.$model.orderId}.json`,
                    documentId: null,
                    blob: new Blob([JSON.stringify($scope.orderItem.$model.order.$model.jsonData, null, 2)], { type: 'text/json' })
                }
            ];
            $scope.isDownloadingFiles = true;

            $q.all([
                filesToExport[0].documentId != null ? fileService.downloadDocumentFile(filesToExport[0].documentId) : $q.when(null),
                filesToExport[1].documentId != null ? fileService.downloadDocumentFile(filesToExport[1].documentId) : $q.when(null)
            ])
                .then(function (data) {
                    //Now as all files are downloaded, add blobs to the array of files which then will be zipped
                    filesToExport[0].blob = data[0];
                    filesToExport[1].blob = data[1];

                    //And zip them all!
                    var zip = jsZip();
                    filesToExport.forEach(function (f) {
                        if (f.blob && f.blob != null) {
                            zip.file(f.fileName, f.blob);
                        }
                    });

                    return zip.generateAsync({ type: 'blob' }).then(function (zipFileBlob) {
                        return saveBlobToFile(zipFileBlob, `${$scope.orderItem.$model.orderId}.zip`);
                    });

                }).then(function () {
                    $scope.$applyAsync(function () {
                        $scope.isDownloadingFiles = false;
                    });
                    toastr.info("Order JSON data and feet scans has been saved for export to Taika3D as Zip file.", "Order files saved");
                })
                .catch(function (err) {
                    $scope.$applyAsync(function () {
                        $scope.isDownloadingFiles = false;
                    });

                    if (err && err.code === 20 && err.name === 'AbortError') {
                        toastr.warning("Export file saving has been cancelled by user.", "Operation cancelled");
                    } else {
                        toastr.error(err.toString(), "Error during Order export generation :(");
                    }
                });
        }

        function saveBlobToFile(blob, suggestedName) {
            // Feature detection. The API needs to be supported
            // and the app not run in an iframe.
            var supportsFileSystemAccess = 'showSaveFilePicker' in window && window.self === window.top;
            // If the File System Access API is supported…
            if (supportsFileSystemAccess) {
                var opts = { suggestedName: suggestedName };

                return window.showSaveFilePicker(opts)
                    .then(function (handle) {
                        // Write the blob to the file.
                        return handle.createWritable()
                            .then(function (writable) {
                                return writable.write(blob)
                                    .then(function () {
                                        return writable.close();
                                    });
                            });
                    });
            } else {
                // Fallback if the File System Access API is not supported…
                // Create the blob URL.
                var blobUrl = URL.createObjectURL(blob);
                // Create the `<a download>` element and append it invisibly.
                var a = document.createElement('a');
                a.href = blobUrl;
                a.download = suggestedName;
                a.style.display = 'none';
                document.body.append(a);
                // Programmatically click the element.
                a.click();
                // Revoke the blob URL and remove the element.
                return $timeout(function () {
                    URL.revokeObjectURL(blobUrl);
                    a.remove();
                }, 1000);
            }
        }
    });
